import { DefaultTheme } from 'styled-components';

const init: DefaultTheme = {
  colors: {
    FAMILY: 'Montserrat,sans-serif',
    WHITE: '#FFFFFF',
    GRAY: '#E6E6E6',
    TEXT_BLUE: '#171754',
    TEXT_GREY: '#707070',
    DARK_GREY: '#808080',
    TEXT_DISABLED: '#B2B2B2',
    LINK: '#171754',
    DROPDOWN_SHADOW: '#000029',
    HEADER_BG: '#E6E6E6',
    FORM_BG: '#E6E6E6',
    INPUT_BORDER: '#E6E6E6',
    INPUT_BG: '#FFFFFF',
    INPUT_FOCUS_BG: '#707070',
    INPUT_FOCUS_BORDER: '#80C2E4',
    INPUT_ENTERED_BG: '#F1F7FF',
    INPUT_ENTERED_BORDER: '#0D8AFF',
    ERROR: '#FF0000',
    BUTTON_BG: '#171754',
    BUTTON_TEXT: '#FFFFFF',
    BUTTON_BORDER: '#171754',
    BUTTON_DARK_BG: '#171754',
    BUTTON_DARK_TEXT: '#FFFFFF',
    BUTTON_DARK_BORDER: '#171754',
    FAQ_TITLE: '#000000',
    ARROW: '#E6E6E6'
  },
  fontSizes: {
    BODY: 16,
    FORM: 14,
    ERROR: 10,
    ATTACHMENT_DESC: 12,
    HEADER_TITLE: 24,
    HEADER_TITLE_M: 18,
    HEADER_CONTENT: 14,
    DISPATCH_PAGE_TITLE: 40,
    DISPATCH_PAGE_TITLE_M: 32,
    DISPATCH_PAGE_TITLE_XS: 26,
    MOBILE_REDIRECT_BUTTON: 15,
    MOBILE_REDIRECT_BUTTON_XS: 12,
    BUTTON_S: 10,
    BUTTON_M: 14,
    BUTTON_L: 16
  }
};

const theme: DefaultTheme = {
  ...init,
  colors: {
    FAMILY: 'Ubuntu,sans-serif',
    WHITE: '#ffffff',
    GRAY: '#F1F7FF',
    TEXT_BLUE: '#000000',
    TEXT_GREY: '#707070',
    DARK_GREY: '#808080',
    TEXT_DISABLED: '#B2B2B2',
    LINK: '#86c4ff',
    DROPDOWN_SHADOW: '#000029',
    HEADER_BG: '#f1f7ff',
    FORM_BG: 'none',
    INPUT_BORDER: '#D5D8DD',
    INPUT_BG: '#FFFFFF',
    INPUT_FOCUS_BG: '#FFFFFF',
    INPUT_FOCUS_BORDER: '#0D8AFF',
    INPUT_ENTERED_BG: '#F1F7FF',
    INPUT_ENTERED_BORDER: '#0D8AFF',
    ERROR: '#FF0000',
    BUTTON_BG: 'transparent',
    BUTTON_TEXT: '#000000',
    BUTTON_BORDER: '#0D8AFF',
    BUTTON_DARK_BG: '#0D8AFF',
    BUTTON_DARK_TEXT: '#ffffff',
    BUTTON_DARK_BORDER: '#0D8AFF',
    FAQ_TITLE: '#6D7787',
    ARROW: '#D5D8DD'
  },
  fontSizes: {
    ...init.fontSizes,
    MOBILE_REDIRECT_BUTTON: 14,
    MOBILE_REDIRECT_BUTTON_XS: 14
  }
};

export default theme;
